import { render, staticRenderFns } from "./ThanksTickComponent.vue?vue&type=template&id=0215f33e"
import script from "./ThanksTickComponent.vue?vue&type=script&lang=ts"
export * from "./ThanksTickComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports